import notificationsTemplate from './notifications.html';

import unkwownCurrenciesURL from './unkwownCurrencies.html';
import { BackendService } from '../../services/BackendService';
import {USER_ACC, NOTIFICATIONS} from '../../services/arsweb/RoutingPaths';

export function fsNotificationsDirective() {
    return {
        restrict: 'E',
        templateUrl: notificationsTemplate,
        controller: NotificationsController,
        controllerAs: 'arsNotifications'
    };
}
class NotificationsController {

    constructor($scope, arsMainDependencies, userService) {
        this.$scope = $scope;
        this.$state = arsMainDependencies.$state;
        this.modal = arsMainDependencies.$mdDialog;
        this.translate = userService.fsMainDependencies.$translate

        userService.fsMainDependencies.initCompletedPromise.then(() => {
            new BackendService(userService, USER_ACC).getUserData(NOTIFICATIONS)
                .then(notifications => this.initNotifications(notifications))
        });
    }

    initNotifications(notificationList) {
        if (notificationList) {
            this.$scope.notificationList = notificationList;
            this.$scope.notificationList.forEach(notification => {
                if (notification.unknwownCurrencies) {
                    notification.colorClass = 'list-group-item-warn';
                    notification.templateURL = unkwownCurrenciesURL;
                }
            });
        }
    }

    showDetailsView(id, detailView) {
        this.$state.go(detailView, { id: id });
    }
}
